<div class="document-modal-overlay" *ngIf="showModal">
  <div class="document-modal">
    <div class="document-modal-header">
      <h2>{{ documentContent?.title || 'Document' }}</h2>
      <button class="close-button" (click)="closeModal()">×</button>
    </div>
    <div class="document-modal-body">
      <div class="document-html-container" *ngIf="documentContent?.description">
        <div [innerHTML]="documentContent.description | safeHtml"></div>
      </div>
      <div class="no-content" *ngIf="!documentContent?.description">
        No content available
      </div>
    </div>
  </div>
</div> 